import moment from 'moment';

export default function dateReducer(state={
		startDate: moment().subtract(1, 'day'),
		endDate: moment()
	}, action) {

	switch( action.type ) {
		case "SET_START_DATE": {
			return {...state, startDate: action.payload}
		}
		case "SET_END_DATE" : {
			return {...state, endDate: action.payload}
		}
		default : {
			return state;
		}
	}
}


// WEBPACK FOOTER //
// ./app/reducers/timeInput/dates.js